<template>
	<div class="bg-gray-100 rounded-xl mt-6 shadow divide-y divide-gray-200">
		<div class="flex justify-between border-b border-gray-200">
			<div class="pl-2 md:pl-6 pr-2 pt-4 py-2 md:py-4 text-xl font-semibold">
				{{
					__(
						"Melden Sie Ihre Ware für die nächste Auktion am"
					)
				}}
				{{ auctionDay }}, {{ __("den") }} {{ auctionDate }} {{ __("an") }}.
			</div>
			<button
				v-on:click="updateAuction()"
				class="hover:bg-gray-100 rounded-lg p-2 ml-auto font-semibold underline text-orange-500 text-lg flex gap-x-2 whitespace-nowrap items-center"
			>
				<ui-icon class="block h-5 w-5" name="x" stroke-width="2.5" />
			</button>
		</div>
		<form @submit.prevent="submit" class="">
			<div class="flex-grow md:grid grid-cols-6">
				<div class="pl-2 md:pl-6 pr-2 pt-4 py-2 md:py-4">
					<div :class="'text-gray-700 focus-within:text-orange-500'">
						<div class="flex justify-start flex-wrap">
							<label class="block font-medium">{{ __("Quantity") }}</label>
							<ui-tooltip
								class="text-green-400 whitespace-normal"
								:icon-stroke-width="2"
								icon-class="ml-1 w-4 h-4"
								:text="'Diese (Teil-) Menge bieten Sie aus Ihrem Verkaufsinserat in der nächste Auktion auf cropspot an. Die Gesamtmenge Ihres Inserats reduziert sich um die Menge, die in die Auktion eingeliefert wurde. So wird eine Doppelvermarktung vermieden.'"
							/>
						</div>
						<div class="mt-1 relative">
							<ui-input-group
								:no-label="true"
								:required="true"
								:form="form"
								:field="'auction.qty_mt'"
								v-model="form.auction.qty_mt"
								suffix="t"
								class="min-w-[4rem] max-w-[6rem] -mt-1"
								:showAsInvalid="offerHasNoQty"
							/>
						</div>
					</div>
				</div>

				<div class="pl-2 md:pl-6 pr-2 pt-4 py-2 md:py-4 md:col-span-2">
					<div :class="'text-gray-700 focus-within:text-orange-500'">
						<div class="flex justify-start flex-wrap">
							<label class="block font-medium">{{ __("Ihr Zielpreis") }}</label>
							<ui-tooltip
								class="text-green-400 whitespace-normal"
								:icon-stroke-width="2"
								icon-class="ml-1 w-4 h-4"
								:text="'Geben Sie hier Ihren Zielpreis für die Auktion an, zu dem Sie verbindlich bereit wären Ihre Ware abzugeben. Erst wenn ein Käufer diesen Mindestpreis bietet, kommt es zu einem Kontrakt.'"
							/>
						</div>
						<div class="mt-1 relative">
							<ui-input-group
								:no-label="true"
								:required="true"
								:form="form"
								:field="'auction.price'"
								v-model="form.auction.price"
								class="-mt-1 md:w-1/2"
								:dp="2"
								suffix="€/t"
								:showAsInvalid="offerHasNoQty"
							/>
							<span class="font-xs">{{
								__("Preise zzgl. der gesetzlichen Mehrwertsteuer")
							}}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="flex justify-between">
				<div class="py-4 px-5 font-semibold">
					<img :src="auctionVerifiedUserUrl" class="inline" />
					{{
						__(
							"Alle Käufer in der Auktion sind von cropspot überprüft und verifiziert"
						)
					}}
				</div>

				<div class="">
					<div class="-mt-10 px-5 md:text-right" v-if="initialAuctionQty > 0">
						<a
							href="#"
							class="truncate bg-white text-orange px-4 py-1.5 font-medium rounded-lg border-orange focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 hover:text-white focus:outline-none font-medium"
							@click="showAuctionDeleteModal = true"
							>{{ __("Menge entfernen") }}</a
						>
					</div>
					<div class="pt-6 px-5 md:text-right">
						<a
							href="#"
							class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 focus:outline-none font-medium"
							@click="saveInput()"
							>{{ __("Speichern") }}</a
						>
					</div>
				</div>
			</div>

			<my-lots-auction-submit-modal
				:form="form"
				:offer="offer"
				:showAuctionSubmittedModal="showAuctionSubmittedModal"
				:auction="auction"
				v-if="showAuctionSubmitModal"
				v-on:close="showAuctionSubmitModal = false"
				@set-submitted-modal="changeSubmittedModal"
			></my-lots-auction-submit-modal>
			<my-lots-auction-submitted-modal
				:offer="offer"
				:auction="auction"
				v-if="showAuctionSubmittedModal"
				v-on:close="showAuctionSubmittedModal = false"
			></my-lots-auction-submitted-modal>
			<my-lots-auction-delete-modal
				:offer="offer"
				:auction="auction"
				v-if="showAuctionDeleteModal"
				v-on:close="showAuctionDeleteModal = false"
			></my-lots-auction-delete-modal>
		</form>
	</div>
</template>

<script>
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		updateAuction: {
			type: Function,
			required: true,
		},
		auction: {
			type: Object,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			showAuctionSubmitModal: false,
			showAuctionSubmittedModal: false,
			showAuctionDeleteModal: false,
			initialAuctionQty: this.offer.auction.qty_mt,
		};
	},
	computed: {
		offerHasNoQty() {
			if (!this.offer.qty.mt || this.offer.qty.mt <= 0) {
				return true;
			}
			return false;
		},
		auctionVerifiedUserUrl() {
			return window.baseUrl + "/images/verified-user.svg";
		},
		auctionDate() {
			if (this.auction !== null) {
				var date = new Date(this.auction.bidding_starts_at);
				return (
					padTo2Digits(date.getDate()) +
					"." +
					padTo2Digits(date.getMonth() + 1) +
					"." +
					date.getFullYear()
				);
			} else {
				return "";
			}
		},
		auctionDay() {
			var date = new Date(this.auction.bidding_starts_at);
			return date.toLocaleString("de-DE", { weekday: "long" });
		},
	},

	methods: {
		changeSubmittedModal(state) {
			this.showAuctionSubmittedModal = state;
		},
		saveInput() {
			let that = this;
			this.form.post(
				this.$route("offers_sell.editInline", { id: this.offer.id }),
				{
					preserveState: true,
					preserveScroll: true,
					onSuccess() {
						that.showAuctionSubmitModal = true;
					},
				}
			);
		},
	},
};
</script>
